import jss from 'jss';
import preset from 'jss-preset-default';
import Configurator from 'bookingbug-configurator-js';
import schema from './branding.schema.json';
import config from './branding.config';
import buttons from './styles/buttons';
import text from './styles/text';
import keyboard from './styles/keyboard';
import body from './styles/body';
import navbar from './styles/navbar';

jss.setup({
  insertionPoint: document.getElementsByTagName('body')[0],
  ...preset(),
});

Configurator.newSchema(schema);
Configurator.loadDefault(config);

const { colors, font } = Configurator.getConfig('branding');

// General style override. This should come from the configurator
const sheet = jss.createStyleSheet({
  '@global': {
    ...buttons(colors),
    ...text(colors),
    ...keyboard(colors),
    ...body(colors, font),
    ...navbar(colors),
  },
});


// This is a specific case to create the CSS for the font
const snippet = document.createElement('link');
snippet.rel = 'stylesheet';
snippet.href = font.url;
document.head.appendChild(snippet);


const { classes: style } = sheet.attach();
export default style;
